<template>
  <div class="content">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold"> {{ fromActorFullName }} </span>
    <span>đã</span>
    <span
      :class="[
        'highlight-action',
        rankingScore.type === TYPE.CONGDIEM ? '' : 'danger'
      ]"
    >
      {{ getTypeLabel(rankingScore.type) }}
      {{ formatNumber(rankingScore.score) }} điểm
    </span>
    <span class="event ">do "{{ rankingScore.note }}"</span>
  </div>
</template>

<script>
import numeral from "numeral";
import rankingUtils from "../../services/rankingUtils";
import constants from "../../constants";

export default {
  name: "notification-item-ranking-score",
  props: ["vbNotificationView"],
  data() {
    return {
      fromActorFullName: null,
      action: null,
      rankingScore: null,
      TYPE: constants.RANKING_REASON.TYPE
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
      this.rankingScore = this.dataJson.rankingScore;
      this.fromActorFullName = this.dataJson.fromActor.fullName;
    },

    formatNumber(value) {
      return numeral(value).format("0.0");
    },

    getTypeLabel(type) {
      return rankingUtils.getTypeLabel(type);
    }
  }
};
</script>

<style scoped>
.highlight-action.danger {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-ranking-score.vue